<div class="dialog-content" fxLayout="row">
    <div class="cover maintenance" fxLayout="column" fxFlex="200px"></div>
    <div class="content" fxLayout="column" fxFlex="500px">
        <h1>MARIS is currently down <br />for maintenance</h1>
        <p>We expect to be back in a couple hours.</p>
        <p>Thanks for your patience and please check back soon.</p>
    </div>
</div>
